module.exports = __webpack_public_path__ + "static/3-085f9b1bfda360cd07d7d3a5a19c1c49.png";